export var ErrorContext = /*#__PURE__*/function (ErrorContext) {
  ErrorContext["I18nAccessPathKey"] = "err.access.path";
  ErrorContext["I18nEntityConnectionKey"] = "err.entity.connection";
  ErrorContext["I18nEntityFormKey"] = "err.entity.form";
  ErrorContext["I18nEntityIssueKey"] = "err.entity.issue";
  ErrorContext["I18nEntityIssueCreateKey"] = "err.entity.issue.create";
  ErrorContext["I18nEntityPreferredFormKey"] = "err.entity.preferredform";
  ErrorContext["I18nEntityProjectKey"] = "err.entity.project";
  ErrorContext["I18nEntityRequestTypeKey"] = "err.entity.requesttype";
  ErrorContext["I18nEntityServiceDeskKey"] = "err.entity.servicedesk";
  ErrorContext["I18nJwtParseKey"] = "err.jwt.parse";
  ErrorContext["I18nJwtSignatureKey"] = "err.jwt.signed";
  ErrorContext["I18nJwtVerifyKey"] = "err.jwt.verify";
  ErrorContext["I18nInternalServerError"] = "err.server.internal";
  ErrorContext["I18nUnknownContextError"] = "err.context.unknown";
  return ErrorContext;
}({});
export function ErrorContextOf(context) {
  switch (context) {
    case ErrorContext.I18nAccessPathKey:
      return ErrorContext.I18nAccessPathKey;
    case ErrorContext.I18nEntityConnectionKey:
      return ErrorContext.I18nEntityConnectionKey;
    case ErrorContext.I18nEntityFormKey:
      return ErrorContext.I18nEntityFormKey;
    case ErrorContext.I18nEntityIssueKey:
      return ErrorContext.I18nEntityIssueKey;
    case ErrorContext.I18nEntityIssueCreateKey:
      return ErrorContext.I18nEntityIssueCreateKey;
    case ErrorContext.I18nEntityPreferredFormKey:
      return ErrorContext.I18nEntityPreferredFormKey;
    case ErrorContext.I18nEntityProjectKey:
      return ErrorContext.I18nEntityProjectKey;
    case ErrorContext.I18nEntityRequestTypeKey:
      return ErrorContext.I18nEntityRequestTypeKey;
    case ErrorContext.I18nEntityServiceDeskKey:
      return ErrorContext.I18nEntityServiceDeskKey;
    case ErrorContext.I18nJwtParseKey:
      return ErrorContext.I18nJwtParseKey;
    case ErrorContext.I18nJwtSignatureKey:
      return ErrorContext.I18nJwtSignatureKey;
    case ErrorContext.I18nJwtVerifyKey:
      return ErrorContext.I18nJwtVerifyKey;
    case ErrorContext.I18nInternalServerError:
      return ErrorContext.I18nInternalServerError;
    default:
      return ErrorContext.I18nUnknownContextError;
  }
}